import React from "react";
import UserAvatar from "metabase/components/UserAvatar";

export const component = UserAvatar;
export const category = "display";

export const examples = {
  "": <UserAvatar />,
};
